import { useTinyHost } from "@tiny/host-contract";

function usePredefinedSegmentsAccess() {
  const { capabilities, upsell } = useTinyHost();
  const canAccessPredefinedSegmentsTab = capabilities.isFeatureEnabled(
    "PRE_BUILD_CUSTOM_SEGMENTS"
  );
  const requestUpgradeForPredefinedSegments = () =>
    upsell.showFeatureUpgrade({ featureName: "PRE_BUILD_CUSTOM_SEGMENTS" });
  return {
    canAccessPredefinedSegmentsTab,
    requestUpgradeForPredefinedSegments,
  };
}

export { usePredefinedSegmentsAccess };
